import { create } from 'zustand';

export const useDialogStore = create((set) => ({
    isOpen: false,
    type: null,
    props: {},
    openDialog: (type, props = {}) => set({ isOpen: true, type, props }),
    closeDialog: () => set({ isOpen: false, type: null, props: {} }),
}));
